module.exports = __webpack_public_path__ + "src/assets/individualImages/bumbleBeeWorker.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/bumbleBeeWorker.png
// module id = ./src/assets/individualImages/bumbleBeeWorker.png
// module chunks = 0